import { useNavigate } from "react-router-dom";
import { Users, Fuel, Settings2, ShieldAlert } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { euro } from "@/lib/api";

export const CarCard = ({ car, index = 0 }) => {
  const navigate = useNavigate();
  return (
    <div
      className="group rounded-2xl overflow-hidden bg-[#181A22] border border-white/10 hover:border-[#E63946]/50 transition-all duration-300 fade-up"
      style={{ animationDelay: `${index * 60}ms` }}
      data-testid={`car-card-${car.id}`}
    >
      <div className="relative aspect-[16/10] overflow-hidden bg-black">
        <img src={car.image_url} alt={`${car.brand} ${car.model}`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        <div className="absolute top-3 left-3 flex gap-2">
          <Badge className="bg-black/70 text-white border-0 font-mono-tech text-[10px] tracking-wider">{car.category}</Badge>
        </div>
        <div className="absolute top-3 right-3">
          <Badge className="bg-[#10B981]/90 text-white border-0 text-[10px]">Pagamento al ritiro ✓</Badge>
        </div>
      </div>
      <div className="p-6">
        <h3 className="font-display font-bold text-xl tracking-tight">{car.brand} {car.model}</h3>
        <div className="flex flex-wrap gap-4 mt-4 text-xs text-muted-foreground">
          <span className="flex items-center gap-1.5"><Settings2 className="w-4 h-4 amber" />{car.transmission}</span>
          <span className="flex items-center gap-1.5"><Fuel className="w-4 h-4 amber" />{car.fuel}</span>
          <span className="flex items-center gap-1.5"><Users className="w-4 h-4 amber" />{car.seats} posti</span>
        </div>
        <div className="flex items-center gap-2 mt-4 text-xs text-[#3B82F6]">
          <ShieldAlert className="w-4 h-4" />
          <span className="font-mono-tech">Cauzione rimborsabile: {euro(car.deposit)}</span>
        </div>
        <div className="flex items-end justify-between mt-6 pt-5 border-t border-white/10">
          <div>
            <div className="font-display font-extrabold text-2xl">{euro(car.daily_rate)}</div>
            <div className="text-[11px] text-muted-foreground font-mono-tech tracking-wider">AL GIORNO</div>
          </div>
          <Button onClick={() => navigate(`/book/${car.id}`)} className="bg-[#E63946] hover:bg-[#D62828] text-white rounded-full px-6 font-semibold" data-testid={`book-car-${car.id}`}>Prenota</Button>
        </div>
      </div>
    </div>
  );
};
